import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import makeStyles from '@mui/styles/makeStyles';
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import Button from "@mui/material/Button";
import { TextInputContainer } from "./TextInput";
import useGetSessionType from "../../constants/sessionType";
import { parseSessionTypes, sessionTypesToNames } from "../../services/RankingFilterHelper";

const useStyles = makeStyles(() => ({
    // il campo non è testuale: niente cursore lampeggiante dopo la chiusura del menu
    noCaret: {
        '& .MuiSelect-select, & .MuiSelect-nativeInput': {
            caretColor: 'transparent'
        }
    },
    footer: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '4px 8px',
        lineHeight: 'normal'
    }
}));

/**
 * Selezione di uno o più tipi di leg per i filtri "Sessione" di classifiche e coppe.
 * Il valore è un array di ordinali (accetta anche la stringa del server, es. "0|1|3").
 * onTextChange riceve sempre un array di ordinali senza duplicati.
 */
export default function SessionTypeSelect({ xs = 12, label, value, onTextChange, error, required = true }) {

    const { t } = useTranslation();
    const classes = useStyles();
    const sessionType = useGetSessionType();
    const selected = parseSessionTypes(value);
    const [open, setOpen] = useState(false);

    return <TextInputContainer
        xs={xs} required={required} label={label}
        value={selected} select
        className={classes.noCaret}
        onTextChange={(newValue) => onTextChange(parseSessionTypes(newValue))}
        error={error}
        SelectProps={{
            multiple: true,
            open,
            onOpen: () => setOpen(true),
            onClose: () => setOpen(false),
            renderValue: (ids) => sessionTypesToNames(ids, sessionType)
        }}>
        {sessionType.map(o =>
            <MenuItem key={o.id} value={o.id}>
                <Checkbox color="secondary" checked={selected.includes(o.id)} />
                <ListItemText primary={o.name} />
            </MenuItem>
        )}
        {/* senza tabindex: il Select non lo tratta come opzione */}
        <ListSubheader component="div" disableSticky className={classes.footer}>
            <Button color="secondary" onClick={() => setOpen(false)}>{t('confirm')}</Button>
        </ListSubheader>
    </TextInputContainer>
}
